import { render } from "./GridView.vue?vue&type=template&id=b0d2f718&ts=true"
import script from "./GridView.vue?vue&type=script&lang=ts"
export * from "./GridView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__